export const AUTH_KEY = 'auth';

export const INITIAL_WORKSPACE_ID_KEY = 'initialWorkspaceID';
